import { SetInternetHeadersArgs } from './InternetHeadersArgs';
import { internetHeaderDictionaryIsValid } from './internetHeaderValidationUtils';
import { getAdapter } from '../../adapters/AdapterManager';
import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { returnErrorIfUserCannotEditItem } from '../sharedProperties/itemPermissions';

export default function setInternetHeadersAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: SetInternetHeadersArgs,
    callback: ApiMethodCallback
) {
    if (!data || !internetHeaderDictionaryIsValid(data.internetHeaderNameValuePairs)) {
        callback(createErrorResult());
        return;
    }
    const adapter: MessageComposeAdapter = getAdapter(hostItemIndex) as MessageComposeAdapter;

    if (returnErrorIfUserCannotEditItem(adapter, callback)) {
        return;
    }

    adapter.setInternetHeaders(data.internetHeaderNameValuePairs);
    callback(createSuccessResult());
}
